// libs
import React from 'react';

// components
import { Star, StarOutline } from '@lyearn/icons';

import BaseRating from '../BaseRating';
// types
import { StarRatingProps } from '..';
// styles
import { CLASSES } from './styles';

const StarRating = (props: StarRatingProps) => {
  const { size = 36, ...rest } = props;

  return (
    <BaseRating
      classes={CLASSES}
      emptyIcon={<StarOutline fillColorToken="icon-secondary" height={size} width={size} />}
      icon={<Star fillColorToken="icon-warning-light" height={size} width={size} />}
      {...rest}
    />
  );
};

export default React.memo(StarRating);
